import React, { useRef, useEffect } from "react";
import {
  I2cTooltip,
  I2cIcon,
  I2cInput,
  I2cDatePicker,
} from "@webcomponents/i2cwebcomponents/dist/react";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import SignatureBox from "../../../Components/SharedComponent/SignatureCanvas/SignatureCanvas";
import FilesUploadService from "../../../Services/FilesUploadService";
import { useMutation } from "react-query";
import Signature from "./Signature";
import { I2cSignature } from "@webcomponents/i2cwebcomponents/dist/react";
const SignOff = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const Manual = useRef(null);

  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    sign_off_client_name: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    sign_off_title: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    sign_off_date: Yup.string()
      .required(generalErrorMessage)
      .min(1, generalErrorMessage),
    // sign_off_signature_type: Yup.string()
    //   .required(generalErrorMessage)
    //   .min(1, generalErrorMessage),
  });
  const fields = [
    "sign_off_client_name",
    "sign_off_title",
    "sign_off_date",
    "sign_off_signature_type",
    "sign_off_signature",
  ];

  useEffect(() => {
    if (!isFetching) {
      try {
        if (!isFetching && Object.keys(formDataJson ?? {}).length) {
          fields.forEach((field) => {
            methods.setValue(field, formDataJson[field] ?? "");
          });
        }
      } finally {
        methods.trigger();
      }
    }
  }, [isFetching]);
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      sign_off_client_name: "",
      sign_off_title: "",
      sign_off_date: "",
      sign_off_signature_type: "",
      sign_off_signature: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData(values);
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_0", true);
  };
  const uploadFiles = function (e) {
    let myPromise = new Promise(function (myResolve, myReject) {
      if (Manual !== null) {
        let dropzone = Manual.current.getDropZone();
        myResolve(dropzone);
      } else {
        myReject("Error");
      }
    });
    myPromise.then(
      function (dropzone) {
        if (dropzone.files.length > 0) {
          for (let i = 0; i < dropzone.files.length; i++) {
            if (dropzone.files[i].status === "added")
              dropzone.enqueueFile(dropzone.files[i]);
          }
        }
        dropzone.on("complete", () => {
          e.target.innerHTML = `Uploaded`;
        });
      },
      function (error) {
        console.log(error);
      },
    );
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("6_0", true);
    else setFormValidStates("6_0", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  const signOptions = [
    {
      label: "Upload",
      value: "file",
      icon: "linear-direct-send",
    },
    {
      label: "Draw",
      value: "signature",
      icon: "linear-edit-2",
    },
  ];

  const titleOptions = [
    {
      label: "Yes",
      value: "yes",
    },
    {
      label: "No",
      value: "no",
    },
  ];
  const formData = new FormData();

  const handleFileUpload = async (name) => {
    try { 
      formData.append("files", Manual.current.fileUpload.files[0]);
      await fileUpload.mutate(formData);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fileUpload = useMutation({
    mutationFn: async (name) => {
      return await FilesUploadService.uploadFileBase64(name);
    },
    onSuccess: (data) => {
      methods.setValue("sign_off_signature", data?.data?.url);
      methods.trigger();
      handleValueChanges();
    },
    onError: (e) => {
      console.log("api error");
    },
  });

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <span slot="label" className="organize-tooltip mb-16">
              <div className="sub-heading">Client Sign Off</div>
              <I2cTooltip
                content="Sign off for the form submitted"
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </span>
          </div>
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <Controller
                name="sign_off_client_name"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className={"single-input-field"}
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                      methods.trigger();
                    }}
                    size="large"
                    label="Name"
                    placeholder="Enter Name"
                    name={"sign_off_client_name"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.sign_off_client_name &&
                  methods.formState.touchedFields.sign_off_client_name
                    ? true
                    : false
                }
                message={
                  errors.sign_off_client_name?.message ?? "Invalid input"
                }
              />
            </div>
            <div className="single-field-wrapper mt-16">
              <Controller
                name="sign_off_title"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className={"single-input-field"}
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                      methods.trigger();
                    }}
                    size="large"
                    label="Title"
                    placeholder="Enter Title"
                    name={"sign_off_title"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.sign_off_title &&
                  methods.formState.touchedFields.sign_off_title
                    ? true
                    : false
                }
                message={errors.sign_off_title?.message ?? "Invalid input"}
              />
            </div>
            <div className="single-field-wrapper mt-16">
              <Controller
                name="sign_off_date"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cDatePicker
                      {...field}
                      name="sign_off_date"
                      onI2cDateApply={(e) => {
                        if (e.target?.appliedDate)
                          field.onChange(
                            e.target?.appliedDate[0]?.toDateString() ?? "",
                          );
                        else field.onChange("");
                        handleValueChanges();
                      }}
                      defaultDate={
                        methods.watch("sign_off_date")
                          ? new Date(methods.watch("sign_off_date"))
                          : ""
                      }
                      I2cDatePicker
                      dateFormat="d-m-Y"
                      maxDate={new Date()}
                      size="large"
                      label="Date"
                    />
                    <span slot="label"></span>
                  </>
                )}
              />
              <ErrorMessage
                show={
                  errors.sign_off_date &&
                  methods.formState.touchedFields.sign_off_date
                    ? true
                    : false
                }
                message={errors.sign_off_date?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="6@md">
            <Signature
              field={fields}
              Manual={Manual}
              methods={methods}
              handleValueChanges={handleValueChanges}
              handleFileUpload={handleFileUpload}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignOff;
